module.exports = __webpack_public_path__ + "static/media/iphone_14_deep_purple_pro.0139306e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_14_deep_purple_pro.jpg
// module id = 2131
// module chunks = 0